// Port seam for the OS keyboard-layout lookup (SCR-7069): the Tauri
// `get_keyboard_layout` IPC lives app-side and the `/ui` zone may not reach
// the app, so `src/utils/dictation-keyboard-wiring.ts` injects it at
// bootstrap. The web path reads `navigator.keyboard` directly.

export interface DictationKeyboardPorts {
  /** Resolves the OS layout identifier (macOS `com.apple.*` id or Windows KLID). */
  getKeyboardLayout: () => Promise<string>;
}

let ports: DictationKeyboardPorts | null = null;

export const configureDictationKeyboardPorts = (next: DictationKeyboardPorts): void => {
  ports = next;
};

export const getDictationKeyboardPorts = (): DictationKeyboardPorts => {
  if (!ports) {
    throw new Error(
      '[dictation/ui/onboarding/keyboard] ports not configured — app ' +
        'bootstrap must call configureDictationKeyboardPorts() (see ' +
        'src/utils/dictation-keyboard-wiring.ts); tests exercising the real ' +
        'hook must configure a test double first.'
    );
  }
  return ports;
};

export const resetDictationKeyboardPortsForTests = (): void => {
  ports = null;
};
